// @flow

import { connect } from 'react-redux';
import React from 'react';

import { login } from 'client/actions/user';

import AccountContainer from './accountContainer';

const FORM_TYPE = 'login';

const mapStateToProps: Object = state => ({
  partnerName: state.partnerName,
});

function bindSubmitHandler(props) {
  return ({ email, password, redirect, source }) =>
    props.login({ email, password, source }).then(() => window.location.replace(redirect));
}

const AccountPage = props => (
  <AccountContainer {...props} isLogin formType={FORM_TYPE} onSubmit={bindSubmitHandler(props)} />
);

export default connect(mapStateToProps, {
  login,
})(AccountPage);
